import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = ["id", "value"]
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "text-input",
      type: "number",
      id: _ctx.id,
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      required: ""
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: _ctx.id,
      class: "label"
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.label), 1)
    ], 8, _hoisted_3)
  ]))
}